<script setup lang="ts">
  import { Badge } from "@ui-kit";
  import { getStatus } from "@src/dictionary";

  const { status, partial } = defineProps<{
    status: string;
    partial?: boolean;
  }>();
</script>

<template>
  <Badge
    isBold
    size="xs"
    class="order-card-status"
    :label="getStatus(status, partial).label"
    :variant="getStatus(status, partial).variant"
    data-testid="order-status"
  />
</template>

<style scoped>
  .order-card-status {
    padding: 4px 8px;
    font-weight: 600;
    white-space: nowrap;
  }
</style>
